import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.png';
import diseno from './img/diseno.png'
import { checkDeviceIOS } from '../../utils'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");


  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    const encodedUsername = encodeURIComponent(username);
    const encodedPassword = encodeURIComponent(password);
    api.userPassLogin(
      {
        username: encodedUsername,
        password: encodedPassword,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-pone-container" ref={nodeRef}>
        <div>
          <div className="diseno">
            <img src={diseno} alt="diseno" id="diseno" />
          </div>
          <img src={logo} alt="logo" id="logopone" className="logo-pone rounded mx-auto d-block" />
        </div>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Row className="login-pone-header">
          </Row>
          <Row className="login-pone-body">
            <Col>
              <div className="pone-container-input">
                <Input
                  className="user-input-pone"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  placeholder={translate('PlaceholderUserName')}
                  onChange={e => setUsername(e.target.value)}
                />
              </div>
              <div className="pone-container-input">
                <Input
                  className="pass-input-pone"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder={translate('PlaceholderPassword')}
                  onChange={e => setPassword(e.target.value)}
                />
                <div className="recover-password-pone">
                  <a href="https://www.somoswim.com/activa-cuenta-paramount">{translate('ForgottenPassword')}</a>
                </div>
              </div>
              {!onLogin ? (
                <div className="container-button-pone">
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-pone"
                  >
                    {translate("ButtonEnter")}
                  </button>

                </div>
              ) : (
                <div className="container-progress-bar-pone" style={{ marginTop: 20 }}>
                  <Progress animated color="danger" value={100} className="pone-progress-bar" />
                </div>
              )}
              <div className="messages-container">
                <Alert
                  color="danger"
                  id="error-message"
                  isOpen={error.open}
                  toggle={() => setError({ open: false })}
                >
                  {error.message}
                </Alert>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="register-account-pone">
                {
                  checkDeviceIOS() ? '' : <p>{translate('CrateAccountText')} <a href="https://somoswim.com/" target="_blank" rel="noopener noreferrer">{translate('CrateAccountLink')}</a></p>
                }
                <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
